export enum MessageStatus {
  IN_PROCESS = "IN_PROCESS",
  FINISHED = "FINISHED",
  STOPPED = "STOPPED",
  FAILED = "FAILED",
}

export enum MessageType {
  DATA = "DATA",
  SERVICE = "SERVICE",
  PROMPT = "PROMPT",
}

export enum MessageSenderType {
  USER = "USER",
  AI_CHAT = "AI_CHAT",
}

export interface IMessageSender {
  id: string;
  type: MessageSenderType;
}

export interface IMessage {
  ai_chat_id: string;
  created_at: string;
  message_id: string;
  message_type: MessageType;
  msg: string;
  sender: IMessageSender;
  status: MessageStatus;
  service_message_key?: string;
}
